export default "__VITE_ASSET__BicnULIV__"